import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import { observer } from "mobx-react-lite";
import Section from "views/common/section";
import { Col, Form } from "react-bootstrap";
import { formatDate } from "utils/localizations";
import FakeInput from "@edaz/edazkit/controls/FakeInput";

const ChangesDuringValiditySection: ViewComponent<CustomerRefundCandidateDetailViewModel> = observer(({ vm }) => {
  return (
    <Section title={vm.translate("changesDuringValidity.licensePlateChangeDuringValidity")}>
      {vm.item.charge.chargeChangesDuringValidity?.map(baseChange =>
        baseChange.changes.map(change => (
          <Form.Row key={baseChange.changedAt.getTime()}>
            <Form.Group as={Col} md={2}>
              <Form.Label>{vm.translate("changesDuringValidity.changeType")}</Form.Label>
              <FakeInput
                target={change}
                property="changedProperty"
                valueFormatter={value => vm.translateChangedProperty(value)}
              />
            </Form.Group>
            <Form.Group as={Col} md={2}>
              <Form.Label>{vm.translate("changesDuringValidity.changeSource")}</Form.Label>
              <FakeInput target={baseChange} property="changeOrigin" valueFormatter={value => vm.translateChangeOrigin(value)} />
            </Form.Group>
            <Form.Group as={Col} md={2}>
              <Form.Label>{vm.translate("changesDuringValidity.changeDate")}</Form.Label>
              <FakeInput target={baseChange} property="changedAt" valueFormatter={value => formatDate(value)} />
            </Form.Group>
            <Form.Group as={Col} md={2}>
              <Form.Label>{vm.translate("changesDuringValidity.newValue")}</Form.Label>
              <FakeInput valueFormatter={() => vm.translateChangedValue(change.changedProperty, change.newValue)} />
            </Form.Group>
            <Form.Group as={Col} md={2}>
              <Form.Label>{vm.translate("changesDuringValidity.oldValue")}</Form.Label>
              <FakeInput valueFormatter={() => vm.translateChangedValue(change.changedProperty, change.originalValue)} />
            </Form.Group>
          </Form.Row>
        ))
      )}
    </Section>
  );
});

export default ChangesDuringValiditySection;
